import * as React from "react"
import {Navigate} from "react-router-dom";

import {SHARE_OF_BROWSE_ROUTES} from "@constants"
import AppLayout from "Layout"
import DigitalShelfKeywordSharePage from "./Share";
import ShareOfSearchPage from "./Details";


export const ShareOfBrowseRoutes = {
    path: SHARE_OF_BROWSE_ROUTES.PATH,
    title: SHARE_OF_BROWSE_ROUTES.TITLE,
    accessKey: SHARE_OF_BROWSE_ROUTES.ACCESS_KEY,
    icon: 'browsers',
    description: "Example test for module Share of Browse",
    element: <AppLayout />,
    children: [{
        element: <Navigate to={SHARE_OF_BROWSE_ROUTES.SHARE_PATH} replace />,  index: true
    }, {
        title: 'Share %',
        path: SHARE_OF_BROWSE_ROUTES.SHARE_PATH,
        dashboardKey: 'share-of-browse-share',
        element: <DigitalShelfKeywordSharePage />
    }, {
        title: 'Details',
        path: SHARE_OF_BROWSE_ROUTES.DETAILS_PATH,
        dashboardKey: 'share-of-browse-section-details',
        element: <ShareOfSearchPage />
    }]
}